import { render, staticRenderFns } from "./TrafxModalUpload.vue?vue&type=template&id=8b5ac182"
import script from "./TrafxModalUpload.vue?vue&type=script&lang=js"
export * from "./TrafxModalUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports